var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"tips_btn mt-2 block cursor-pointer",on:{"click":_vm.toggleTestTools}},[_c('img',{staticClass:"object-contain",attrs:{"src":require("@/assets/image/ai/test_btn.png"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }